const getSubCategories = (categoryList = [], categoryObject = {}) => {
  const newCat = { ...categoryObject };
  const subcats = categoryList.filter(
    (cat) => cat.parent === categoryObject.id
  );

  if (!subcats?.length) {
    newCat.name = newCat.name
      .replace(/&lt;/g, "<")
      .replace(/&gt;/g, ">")
      .replace(/&amp;/g, "&");
    return newCat;
  }

  newCat.subcategories = subcats.map((subcat) => ({
    ...getSubCategories(categoryList, subcat),
  }));

  return newCat;
};

export const getCategoryTree = (categoryList = []) => {
  const categories = [...categoryList];
  const categoryTree = categories
    .filter((cat) => cat.parent === 0)
    .map((category, index) => ({
      ...getSubCategories(categories, category),
      categoryIndex: index,
    }));

  return categoryTree;
};

export const findCategory = (categoryTree = [], id) => {
  let foundCategory = null;
  let i = 0;
  while (!foundCategory && i < categoryTree.length) {
    if (categoryTree[i].id === id) {
      foundCategory = categoryTree[i];
    } else if (categoryTree[i].subcategories?.length) {
      foundCategory = findCategory(categoryTree[i].subcategories, id);
    }

    i += 1;
  }

  return foundCategory;
};

export const groupCategoryIds = (categoryTree, categoryIds = []) => {
  const groupedCategories = {};
  categoryIds.forEach((id) => {
    const foundCat = findCategory(categoryTree, id);
    if (!groupedCategories[foundCat.parent]) {
      groupedCategories[foundCat.parent] = [];
    }

    groupedCategories[foundCat.parent].push(id);
  });

  return groupedCategories;
};
